import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { Link } from 'react-router-dom';

const {
  FiUsers,
  FiCalendar,
  FiHome,
  FiAward,
  FiAlertTriangle,
  FiQrCode,
  FiClock,
  FiLogIn
} = FiIcons;

const Header = ({ currentView, onNavigate }) => {
  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: FiHome },
    { id: 'members', label: 'Members', icon: FiUsers },
    { id: 'attendance', label: 'Meeting Control', icon: FiCalendar },
    { id: 'absences', label: 'Outreach Needed', icon: FiAlertTriangle },
    { id: 'history', label: 'Meeting History', icon: FiClock },
    { id: 'qr-generator', label: 'QR Code', icon: FiQrCode },
    { id: 'check-in', label: 'Check-In', icon: FiLogIn },
    { id: 'results', label: 'Results', icon: FiAward }
  ];

  return (
    <header className="bg-white shadow-lg border-b-4 border-brand-primary">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          <motion.div
            className="flex items-center space-x-4"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="w-16 h-16 flex items-center justify-center">
              {/* Use a more reliable URL for the logo */}
              <img
                src="/moco-png-logo.png"
                alt="MOCO PNG Logo"
                className="w-full h-full object-contain"
                onError={(e) => {
                  // Fallback to text if image fails to load
                  e.target.style.display = 'none';
                }}
              />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-brand-primary">MOCO PNG</h1>
              <p className="text-sm text-gray-600">Montgomery County Professional Networking Group</p>
            </div>
          </motion.div>

          <nav className="flex space-x-1">
            {navItems.map((item, index) => (
              <motion.button
                key={item.id}
                onClick={() => onNavigate(item.id)}
                className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-all duration-200 ${
                  currentView === item.id
                    ? 'bg-brand-primary text-white shadow-lg'
                    : 'text-gray-600 hover:bg-gray-100 hover:text-brand-primary'
                }`}
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <SafeIcon icon={item.icon} className="text-lg" />
                <span className="font-medium hidden lg:inline text-sm">{item.label}</span>
              </motion.button>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;